import { render, staticRenderFns } from "./RedareaUploader.vue?vue&type=template&id=57e5f21d&scoped=true&"
import script from "./RedareaUploader.vue?vue&type=script&lang=js&"
export * from "./RedareaUploader.vue?vue&type=script&lang=js&"
import style0 from "./RedareaUploader.vue?vue&type=style&index=0&id=57e5f21d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e5f21d",
  null
  
)

export default component.exports